import Eye from '../Icons/Eye';

type Props = {
  bg?: 'bg-white-100' | 'bg-white-5';
};

const ImagePlaceholder = ({ bg = 'bg-white-100' }: Props) => {
  return (
    <div
      className={`${bg} ${
        bg === 'bg-white-100' ? 'text-white-5' : 'text-white-100'
      } flex h-full w-full items-center justify-center rounded-24`}
    >
      <Eye />
    </div>
  );
};

export default ImagePlaceholder;
